import React from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import './styles/main.scss'
import store, { history } from './store'

import Raven from 'raven-js'

if (process.env.REACT_APP_SENTRY_DSN_URL) {
  Raven
    .config(process.env.REACT_APP_SENTRY_DSN_URL)
    .install()
}

const MOUNT_NODE = document.getElementById('root')

// @see https://github.com/davezuko/react-redux-starter-kit/blob/master/src/main.js
let renderApp = () => {
  const App = require('./components/App').default
  const routes = require('./routes/index').default

  render(
    <App
      store={store}
      history={history}
      routes={routes}
    />,
    MOUNT_NODE
  )
}

if (module.hot) {
  module.hot.accept([
    './components/App',
    './routes/index'
    ], () => {
    unmountComponentAtNode(MOUNT_NODE)
    renderApp()
  })
}

renderApp()



// WEBPACK FOOTER //
// ./src/index.js